import { useEffect, useRef } from 'react';
import type { CheckResult, Photo } from '@transpordiamet/shared';

/** Failed VIN or vehicle check the user is allowed to confirm. */
export function bypassableFailure(photo: Photo): CheckResult | undefined {
  return photo.checks.find(
    (check) => !check.passed && check.allow_bypass && (check.type === 'vin' || check.type === 'is_car')
  );
}

/**
 * Show the confirm dialog again when a reload dropped it.
 * The same draft is offered once per mount; a retake stays dismissed until remount.
 */
export function usePendingDraft(
  stepId: string | undefined,
  drafts: Photo[] | undefined,
  enabled: boolean,
  present: (checkResult: CheckResult, photoId: string) => void
) {
  const shown = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled || !stepId) return;
    const draft = drafts?.find((item) => item.stepId === stepId);
    if (!draft || shown.current === draft.id) return;
    const failure = bypassableFailure(draft);
    if (!failure) return;
    shown.current = draft.id;
    present(failure, draft.id);
  }, [drafts, enabled, present, stepId]);
}
